import { get } from 'lodash';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { State } from 'src/common/store';
import { ApplicationStatus, AttestationStatus } from '../enums/application-status.enum';
import { getCurrentAttestation } from '../thunks/attestation-thunks';

let interval: any = null;

export const useTest = () => {
  const dispatch = useDispatch();
  // const router: any = useRouter();
  // const { user } = useAuth();
  const { current } = useSelector((state: State) => state.attestation);

  const getCurrent = () => dispatch(getCurrentAttestation());

  const startPingPong = () => {
    interval = setInterval(() => {
      getCurrent();
    }, 1000);
  };

  const endPingPong = () => {
    clearInterval(interval);
  };

  const applicationId = get(current, ['data', 'id']);
  const attestationStatus = get(current, ['data', 'attestationStatus']);
  const status = get(current, ['data', 'status']);
  // const language = get(current, ['data', 'language'], 'uz');

  useEffect(() => {
    // if (router.query.start && applicationId)
    // dispatch(startAttestation({ id: get(user, 'data.id'), language }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [applicationId]);

  useEffect(() => {
    if (!attestationStatus && status === ApplicationStatus.CONFIRMED) {
      startPingPong();
    }
    if ([AttestationStatus.STARTED, AttestationStatus.COMPLETED].includes(attestationStatus)) {
      endPingPong();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [attestationStatus, status]);

  useEffect(() => {
    getCurrent();

    return endPingPong;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    ...current,
    getCurrent,
    startPingPong,
    endPingPong,
  };
};
